/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createBitXor } from '../../factoriesAny.js';
export var bitXorDependencies = {
  DenseMatrixDependencies,
  matrixDependencies,
  typedDependencies,
  createBitXor
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesBitXor.generated.js
// module id = 1319
// module chunks = 2